import { ExpenseItemListPage } from '@/features/expense-item/pages/ExpenseItemListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/expense-item/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["expense_item.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ExpenseItemListPage,
})
